import type { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import type { Partner } from '../../api.js';

interface PartnerSettingsPanelProps {
  selected: Partner;
  selectedTenantCount: number;
  editCap: string;
  busy: boolean;
  onEditCapChange: (value: string) => void;
  onSaveCap: (event: FormEvent) => void;
  onToggleStatus: () => void;
  onToggleCustomModels: () => void;
  onDelete: () => void;
}

export function PartnerSettingsPanel({
  selected,
  selectedTenantCount,
  editCap,
  busy,
  onEditCapChange,
  onSaveCap,
  onToggleStatus,
  onToggleCustomModels,
  onDelete
}: PartnerSettingsPanelProps) {
  const { t } = useTranslation();
  return (
    <section className="panel">
      <h2>
        {t('partners.managing')}: {selected.name} <small>{selected.id}</small>
      </h2>

      <form className="toolbar-form" onSubmit={onSaveCap}>
        <label>{t('partners.tenantCap')}</label>
        <input
          value={editCap}
          inputMode="numeric"
          placeholder={t('partners.unlimited')}
          onChange={(event) => onEditCapChange(event.target.value)}
          autoComplete="off"
        />
        <button disabled={busy}>{t('partners.saveCap')}</button>
        <button type="button" disabled={busy} onClick={onToggleStatus}>
          {selected.status === 'active' ? t('partners.suspend') : t('partners.activate')}
        </button>
        <button type="button" disabled={busy} onClick={onToggleCustomModels}>
          {selected.allowCustomModels ? t('partners.disableCustomModels') : t('partners.enableCustomModels')}
        </button>
        <button type="button" disabled={busy || selectedTenantCount > 0} onClick={onDelete}>
          {t('partners.deletePartner')}
        </button>
        {selectedTenantCount > 0 && <span className="muted">{t('partners.deleteBlocked', { count: selectedTenantCount })}</span>}
      </form>
    </section>
  );
}
